module.exports = __webpack_public_path__ + "static/img/distance-bg.5a0a917.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/article/distance-bg.png
// module id = Ms+3
// module chunks = 1